<template>
  <div class="flex justify-center items-center fixed z-[99999] left-0 top-0 overflow-auto bg-black bg-opacity-40 xs:w-full xs:h-full sm:py-24 md:pt-24">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Modal",
};
</script>

<style scoped></style>
